import Vue from "vue";

export default Vue.mixin({
  methods: {
    isMobile(width) {
      return width < 768;
    }
  }
});
